
(function(){
  function init(){
    document.querySelectorAll('[data-pc-catalog-card]').forEach(function(card){
      if(card.dataset.pcReady==='1')return; card.dataset.pcReady='1';
      var image=card.querySelector('.pc-catalog-card__image:not(.pc-catalog-card__image--alternate)');
      var original=image ? image.getAttribute('src'):null;
      if(!image)return;
      card.querySelectorAll('[data-variant-photo]').forEach(function(swatch){
        swatch.addEventListener('mouseenter',function(){
          if(!swatch.dataset.variantPhoto)return;
          image.src=swatch.dataset.variantPhoto;
          image.removeAttribute('srcset');
          var secondary=card.querySelector('.pc-catalog-card__image--alternate');
          if(secondary)secondary.style.opacity='0';
        });
        swatch.addEventListener('focus',function(){if(swatch.dataset.variantPhoto){image.src=swatch.dataset.variantPhoto;image.removeAttribute('srcset');}});
      });
      card.addEventListener('mouseleave',function(){
        if(original){image.src=original;var secondary=card.querySelector('.pc-catalog-card__image--alternate');if(secondary)secondary.style.opacity='';}
      });
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
  var container=document.getElementById('ProductGridContainer');
  if(container&&window.MutationObserver){new MutationObserver(init).observe(container,{childList:true,subtree:true});}
})();
